import { DailyTrip } from "../trips/dailyTrip";
import { Expense } from "../expenses/expense";
import { VehicleCashout } from './vehicle-cashout';

export class VehicleIncomeReport {
    vehicleId: number;
    plateNumber: string;

    dailyTrips: DailyTrip[];
    expenses: Expense[];
    cashouts: VehicleCashout[];

    totalTripRate: number;
    totalDriverRate: number;
    totalHelperRate: number;
    
    totalKarga: number;
    totalXray: number;
    totalSoli: number;
    totalDagSoli: number;
    totalAreglo: number;
    totalEscort: number;
    totalShippingLineFee: number;
    totalCFee: number;
    totalTollGate: number;
    totalTollGateEmpty: number
    totalManPower: number;
    totalSingitPier2: number;
    totalRemarksFee: number;
    totalAllowance: number;
    totalCashDiesel: number;
    totalCashDieselEmpty: number;
    totalLiters: number;
    totalLitersEmpty: number;
    totalLitersAmount: number;
    totalLitersEmptyAmount: number;
    totalTabs: number;
    totalTabsPenalty: number;

    totalDailyTripExpense: number;

    totalOtherDailyTripExpense: number;
    totalExpense: number;
    totalOtherExpense: number;

    grossIncome: number;
    netIncome: number;
    totalCashout: number;

    constructor() {
        this.dailyTrips = [];
        this.expenses = [];
    }
}


// WEBPACK FOOTER //
// ./src/app/models/vehicles/vehicle.income.report.ts